import React, { useEffect, useState } from "react";
import styles from "../Parts/Parts.module.css";
import parts_Type_Data from "../../Data/RO-landing.json";
import { TiTick } from "react-icons/ti";

const Parts = () => {
  // filtering service type data and storing in avariable using useEffect Hook....
  const [parts, setParts] = useState();

  useEffect(() => {
    let parts_Data = parts_Type_Data.map((data, index) => {
      setParts(data.spareParts);
    });
  }, []);

  return (
    <>
      <div className={styles.container}>
        {parts?.map((elem, index) => {
          return (
            <>
              <div className={styles.card}>
                <h2>* {elem.title}</h2>
                <div className={styles.card_Inner}>
                  {elem.spareParts.map((data, index) => {
                    return (
                      <>
                        <div className={styles.name_price}>
                          <p>{data.partName}</p>
                          <p>{data.price}</p>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default Parts;
